module.exports = __webpack_public_path__ + "img/footprint-arch-normal.89ad3e6f.svg";